import { jsx as _jsx } from "react/jsx-runtime";
/** The performance overlay over the viewport, shown while the Display menu's Performance toggle is on. */
import { useViewportMode } from '../contexts/ViewportModeContext.js';
import { useFrameStats } from './FrameStatsContext.js';
import { PerformancePanel } from './PerformancePanel.js';
export function PerformanceOverlay() {
    const { showPerformance } = useViewportMode();
    const stats = useFrameStats();
    return showPerformance ? _jsx(PerformancePanel, { stats: stats }) : null;
}
//# sourceMappingURL=PerformanceOverlay.js.map